import React, {useContext} from 'react';
import {
    SimpleFormIterator,
    ReferenceInput,
    FormTab,
    FormDataConsumer,
    useResourceContext,
    TextField,
    ArrayInput
} from 'react-admin';
import { StaffInput } from '../../Common/StaffInput';
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";
import { Typography, Box, Divider, Chip } from '@mui/material';
import { ReadOnlyContext } from '../../../lib/context/ReadOnlyContext';
import { useAzureADGroups } from '../../../msal/useAzureADGroups';
import { useParams } from 'react-router-dom';

var titleStyle = { color: "#AE223F" }
var labelStyle = { color: "inherit" }
export const CourseTeamInputs = (source) => {
    const resource = useResourceContext();
    const readonly = useContext(ReadOnlyContext) || false
    const { isHeadOfSubject } = useAzureADGroups();
    let isHistoric = false;
    const params = useParams();
    if(params.id?.length > 10){
        isHistoric = true;
    }


    return (
        <FormTab label="Course Team" {...source}>
              <Box flex={4} sx={{ paddingBottom: '20px' }}>
              <Typography variant="h6" style={titleStyle}>
                    Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
                </Typography>
            </Box>
            <Box display="flex" width={1}>
                <Box flex={1}>
                    <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Course Leaders (2 max)" /></b></Divider>
                </Box>
            </Box>
            <ArrayInput source="courseLeaders" label={false} disabled={(readonly && !isHeadOfSubject) || (readonly && isHistoric)}>
                <SimpleFormIterator disableReordering fullWidth>
                    <FormDataConsumer>
                        {({ formData, getSource, scopedFormData }) => (
                            <StaffInput
                                teamName="courseLeaders"
                                formData={formData}
                                getSource={getSource}
                                scopedFormData={scopedFormData}
                            />
                        )}
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
            <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Course Team" /></b></Divider>
                    </Box>
                </Box>
            <ArrayInput source="courseTeams" label={false} disabled={(readonly && !isHeadOfSubject) || (readonly && isHistoric)}>
                <SimpleFormIterator disableReordering fullWidth>
                    <FormDataConsumer>
                        {({ formData, getSource, scopedFormData }) => (
                            <StaffInput
                                teamName="courseTeams"
                                formData={formData}
                                getSource={getSource}
                                scopedFormData={scopedFormData}
                            />
                        )}
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
            <VersioningTypeInput source="versioningType" resource={resource} />
        </FormTab>
    );
};
